import { InputGroup } from 'react-bootstrap'
import { TextInput } from '@ztechapps/webui.input'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'

export const TextInputWithSubmit = (props) => {
  const isSubmitting = props?.form?.isSubmitting

  return (
    <InputGroup>
      <TextInput placeholder="Enter the email address" {...props} />
      <BusyButton type="submit" text="Submit" isBusy={isSubmitting} disabled={props.meta?.error} />
    </InputGroup>
  )
}
